export class policyMappingDescription {
  Jurisdiction: string;
  User: string | undefined;
  Description: string;
  IsOriginal: boolean;
  Id: number;
  isChecked: boolean;
  constructor() {
    this.Jurisdiction = '';
    this.User = '';
    this.Description = '';
    this.IsOriginal = false;
    this.Id = 0;
    this.isChecked = false;
  }
}
